import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { getContests } from "../../api/asyncThuncks/contestsCards";
import ActiveСontests from "./components/ActiveСontests";
import InactiveContests from "./components/InactiveContests";
import { selectContestsState } from "../../store/slices/contests";
import { setSEOSettings } from "../../store/slices/main";
import EmptyContentList from "../../components/emptyContent/components/EmptyContentList";

const СontestsContainer = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { contests } = useAppSelector(selectContestsState);

  const navigateAndSetSEOSettings = (
    link: string,
    appTitle: string,
    appDescription: string,
    appImg: string
  ) => {
    navigate(`${link}`);
    dispatch(
      setSEOSettings({
        appTitle,
        appDescription,
        appImg,
      })
    );
  };

  useEffect(() => {
    dispatch(getContests());
  }, [dispatch]);

  const hasActiveContests = contests?.active && contests.active.length > 0;
  const hasInactiveContests =
    contests?.inactive && contests.inactive.length > 0;
  return (
    <>
      {!hasActiveContests && !hasInactiveContests ? (
        <EmptyContentList />
      ) : (
        <div className="flex flex-col justify items-center bg-white">
          <div className="w-full px-5 pt-9 bg-white md:max-w-[1000px] overflow-x-hidden md:px-0">
            <div className="w-full">
              <h1 className="pb-5 text-2xl font-bold">Конкурси</h1>
            </div>
          </div>
          {hasActiveContests && (
            <div
              className="w-screen flex justify-center py-9 bg-gradient bg-gradient-to-r from-[#F0F4FF] to-[#F2EDFF]"
              style={{
                background:
                  "linear-gradient(90deg, hsla(251, 100%, 97%, 1) 0%, hsla(231, 100%, 97%, 1) 100%)",
              }}
            >
              <div className="w-full md:max-w-[1000px] px-5 md:px-0">
                <div className="flex justify-start items-center">
                  <h2 className="text-xl pr-2.5 text-black font-bold pb-4">
                    Поточні конкурси
                  </h2>
                </div>
                <div className="w-full">
                  {contests?.active.map((activeCard) => (
                    <div key={activeCard.id} className="w-full py-3 md:px-0">
                      <ActiveСontests
                        icon={activeCard.imgPath}
                        title={activeCard.title}
                        description={activeCard.description}
                        ctaButtonTitle={activeCard.ctaButtonTitle}
                        activePublicUrl={activeCard.publicUrl}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          {hasInactiveContests && (
            <div className="w-full px-5 pt-9 bg-white md:max-w-[1000px] md:px-0 md:pb-0">
              <div className="flex items-center py-3">
                <h2 className="text-xl pr-2.5 text-black font-bold">
                  Завершені конкурси
                </h2>
              </div>
              <div className="w-full flex justify-between flex-wrap">
                {contests?.inactive.map((inactivCard) => (
                  <div
                    key={inactivCard.id}
                      onClick={() =>
                      navigateAndSetSEOSettings(
                        `/contests/${inactivCard.publicUrl}`,
                        inactivCard.title,
                        inactivCard.metaDescription
                          ? inactivCard.metaDescription
                          : inactivCard.description,
                        inactivCard.imgPath
                      )
                    }
                  >
                    <InactiveContests
                      icon={inactivCard.imgPath}
                      title={inactivCard.title}
                      date={inactivCard.createdAt}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default СontestsContainer;
